import { render, staticRenderFns } from "./OpsAppVersion.vue?vue&type=template&id=20025723&scoped=true&"
import script from "./OpsAppVersion.vue?vue&type=script&lang=js&"
export * from "./OpsAppVersion.vue?vue&type=script&lang=js&"
import style0 from "./OpsAppVersion.vue?vue&type=style&index=0&id=20025723&scoped=true&lang=css&"
import style1 from "./OpsAppVersion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20025723",
  null
  
)

export default component.exports